/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DownlinkCommandStatusDto } from '../../models/downlink-command-status-dto';

export interface GetDownlinkCommandStatus$Params {
  identifier: string;
}

export function getDownlinkCommandStatus(http: HttpClient, rootUrl: string, params: GetDownlinkCommandStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<DownlinkCommandStatusDto>> {
  const rb = new RequestBuilder(rootUrl, getDownlinkCommandStatus.PATH, 'get');
  if (params) {
    rb.path('identifier', params.identifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DownlinkCommandStatusDto>;
    })
  );
}

getDownlinkCommandStatus.PATH = '/api/regdevice/dlcommand/{identifier}';
